import React, { useEffect, useState } from "react";
import { PublicHeader } from "@/components/PublicHeader";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { SEO_FAQ } from "@/lib/seo-defs";
import { Badge } from "@/components/ui/badge";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { api } from "@/lib/api";

export default function FAQPage() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    api.get("/public/faqs").then(r => setFaqs(r.data || [])).catch(() => {});
  }, []);
  const categories = [...new Set(faqs.map(f => f.category || "Generale"))];
  return (
    <div className="min-h-screen">
      <SEO {...SEO_FAQ} />
      <PublicHeader />
      <section className="pt-28 pb-12 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <Badge className="bg-[#EAF0FF] text-[#2D6BFF] border-0">FAQ</Badge>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900">Domande frequenti</h1>
          <p className="mt-5 text-lg text-slate-600">Risposte rapide sul funzionamento di CXOORA, sui costi e sulla selezione dei manager.</p>
        </div>
      </section>
      <section className="py-12 bg-[#F6F8FC]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 space-y-8">
          {categories.map(cat => (
            <div key={cat}>
              <h2 className="text-sm font-semibold uppercase tracking-wider text-slate-500 mb-3">{cat}</h2>
              <Accordion type="single" collapsible className="cxo-card divide-y divide-slate-200">
                {faqs.filter(f => (f.category || "Generale") === cat).map((f, idx) => (
                  <AccordionItem key={f.id} value={`item-${cat}-${idx}`} className="border-0">
                    <AccordionTrigger className="px-5 py-4 text-left font-semibold text-slate-900 hover:no-underline">{f.question}</AccordionTrigger>
                    <AccordionContent className="px-5 pb-4 text-slate-600 leading-relaxed">{f.answer}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
          {faqs.length === 0 && <p className="text-center text-slate-500">Nessuna domanda al momento.</p>}
        </div>
      </section>
      <Footer />
    </div>
  );
}
